"use strict";
/**
 * Entrypoint of the stopify-continuations bundle
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const lazyRuntime_1 = require("./lazyRuntime");
const eagerRuntime_1 = require("./eagerRuntime");
const retvalRuntime_1 = require("./retvalRuntime");
const fudgeRuntime_1 = require("./fudgeRuntime");
__export(require("./abstractRuntime"));
let savedRTS;
function newRTS(transform) {
    if (!savedRTS || savedRTS.kind !== transform) {
        switch (transform) {
            // Default to shallow runtime.
            case 'catch':
                savedRTS = new lazyRuntime_1.LazyRuntime(Infinity, Infinity);
                savedRTS.kind = 'catch'; // TODO(arjun): Sloppy
                break;
            case 'lazy':
                savedRTS = new lazyRuntime_1.LazyRuntime(Infinity, Infinity);
                break;
            case 'eager':
                savedRTS = new eagerRuntime_1.EagerRuntime(Infinity, Infinity);
                break;
            case 'retval':
                savedRTS = new retvalRuntime_1.RetvalRuntime(Infinity, Infinity);
                break;
            case 'fudge':
                savedRTS = new fudgeRuntime_1.FudgeRuntime();
                break;
            default: throw new Error(`bad runtime: ${transform}`);
        }
    }
    return savedRTS;
}
exports.newRTS = newRTS;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVudGltZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ydW50aW1lL3J1bnRpbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOztHQUVHOzs7OztBQUdILCtDQUE0QztBQUM1QyxpREFBOEM7QUFDOUMsbURBQWdEO0FBQ2hELGlEQUE4QztBQUU5Qyx1Q0FBa0M7QUFFbEMsSUFBSSxRQUFpQyxDQUFDO0FBQ3RDLFNBQWdCLE1BQU0sQ0FBQyxTQUFpQjtJQUN0QyxJQUFJLENBQUMsUUFBUSxJQUFJLFFBQVEsQ0FBQyxJQUFJLEtBQUssU0FBUyxFQUFFO1FBQzVDLFFBQVEsU0FBUyxFQUFFO1lBQ2pCLDhCQUE4QjtZQUM5QixLQUFLLE9BQU87Z0JBQ1YsUUFBUSxHQUFHLElBQUkseUJBQVcsQ0FBQyxRQUFRLEVBQUUsUUFBUSxDQUFDLENBQUM7Z0JBQy9DLFFBQVEsQ0FBQyxJQUFJLEdBQUcsT0FBTyxDQUFDLENBQUMsc0JBQXNCO2dCQUMvQyxNQUFNO1lBQ1IsS0FBSyxNQUFNO2dCQUFFLFFBQVEsR0FBRyxJQUFJLHlCQUFXLENBQUMsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFDO2dCQUFDLE1BQU07WUFDbkUsS0FBSyxPQUFPO2dCQUFFLFFBQVEsR0FBRyxJQUFJLDJCQUFZLENBQUMsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFDO2dCQUFDLE1BQU07WUFDckUsS0FBSyxRQUFRO2dCQUFFLFFBQVEsR0FBRyxJQUFJLDZCQUFhLENBQUMsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFDO2dCQUFDLE1BQU07WUFDdkUsS0FBSyxPQUFPO2dCQUFFLFFBQVEsR0FBRyxJQUFJLDJCQUFZLEVBQUUsQ0FBQztnQkFBQyxNQUFNO1lBQ25ELE9BQU8sQ0FBQyxDQUFDLE1BQU0sSUFBSSxLQUFLLENBQUMsZ0JBQWdCLFNBQVMsRUFBRSxDQUFDLENBQUM7U0FDdkQ7S0FDRjtJQUNELE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUM7QUFoQkQsd0JBZ0JDIn0=


//////////////////
// WEBPACK FOOTER
// .-continuations/dist/src/runtime/runtime.js
// module id = 327
// module chunks = 0